<template>
  <div id="websiteproduct">
    <DisplayProduct></DisplayProduct>
  </div>
</template>

<script>
import DisplayProduct from "@/components/global-components/DisplayProduct.vue";

export default {
  name: "WebsiteProductView",

  components: { DisplayProduct },

  data() {
    return {};
  },

  computed: {},

  methods: {},
};
</script>
